<template>
  <v-alert type="success">
    {{ $t('profile.registration.success') }} <b>{{ email }}</b
    >.

    <v-btn variant="flat" color="primary" class="mt-3 clickable" :disabled="resendDisabled" @click="resend">
      <v-icon class="mr-3">mdi-send</v-icon>
      {{ $t('profile.registration.resend') }}
    </v-btn>
  </v-alert>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import api from '@/venit/components/cortona-venit/services/api';

const props = defineProps<{
  token: string;
  email: string;
}>();

const resendDisabled = ref(false);

const resend = () => {
  resendDisabled.value = true;
  setTimeout(() => (resendDisabled.value = false), 30000);
  api.activationResend(props.token);
};
</script>

<style scoped></style>